import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { optionPropTypes } from './common';
import DropDownPicker from './DropDown';
import InlinePicker from './Inline';
import createElementResizeDetectorRef from '../../helpers/createElementResizeDetectorRef';
import theme from '../../styles/theme';

class CategoryPicker extends PureComponent {
  state = { inline: false };

  setRef = createElementResizeDetectorRef(({ el, width }) => {
    const inlineContainer = el.childNodes[1];
    const { width: inlineWidth } = inlineContainer.getBoundingClientRect();
    this.setState({ inline: inlineWidth < width });
  });

  render() {
    const { classes, className, options } = this.props;
    const { inline } = this.state;
    const renderPickers = Component => options.map((optionsItem, i) => (
      <Component
        key={i} // eslint-disable-line react/no-array-index-key
        className={classes.picker}
        {...optionsItem}
      />
    ));
    return (
      <div className={cn(className, classes.container, inline && classes.inline)} ref={this.setRef}>
        <div className={classes.dropdownPickers}>
          {renderPickers(DropDownPicker)}
        </div>
        <div className={classes.inlinePickers}>
          {renderPickers(InlinePicker)}
        </div>
      </div>
    );
  }
}

CategoryPicker.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape(optionPropTypes)).isRequired,
};

CategoryPicker.defaultProps = {
  className: undefined,
};

export default injectSheet({
  container: {
    width: '100%',
    position: 'relative',
    marginRight: 0,
    [theme.breakpoints.up('md')]: {
      marginRight: 40,
    },
  },
  inline: {
    '& > $dropdownPickers': {
      [theme.breakpoints.up('md')]: {
        visibility: 'hidden',
      },
    },
    '& > $inlinePickers': {
      [theme.breakpoints.up('md')]: {
        visibility: 'visible',
      },
    },
  },
  dropdownPickers: {
    visibility: 'visible',
  },
  inlinePickers: {
    visibility: 'hidden',
    whiteSpace: 'nowrap',
    position: 'absolute',
    left: 0,
    top: 0,
  },
  picker: {
    display: 'inline-block',
    '&:not(:first-child)': {
      marginLeft: 16,
      [theme.breakpoints.down('sm')]: {
        marginLeft: -8,
      },
      '$inlinePickers > &': {
        marginLeft: 52,
      },
    },
  },
})(CategoryPicker);
